import { FC, useState } from 'react';
import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';

import { Share } from 'types';
import { useGetSocietyShareTitleDocument } from 'modules/partners/pages/ShareTitleList/hooks/useGetSocietyShareTitleDocument';
import { useShares } from 'modules/partners/hooks/useShares';
import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';

import PartnerSharesTable from './components/PartnerSharesTable';
import { UseGetShareTitlesByShares } from './hooks/useGetShareTitlesByShares';

type PartnerSocietySharesDetailsProps = {
  partnerId: string;
  coOwnerShares: Share[];
  totalItems: number;
  isAdmin: boolean;
  isCoOwner: boolean;
  hasSharesTitlesEnabled: boolean;
  hasMainSharesTitleDisabled: boolean;
  fetchPartnerData?: () => void;
};

const PartnerSocietySharesDetails: FC<PartnerSocietySharesDetailsProps> = ({
  partnerId,
  coOwnerShares,
  totalItems,
  isAdmin,
  isCoOwner,
  hasSharesTitlesEnabled,
  hasMainSharesTitleDisabled,
  fetchPartnerData = () => {},
}: PartnerSocietySharesDetailsProps) => {
  const shares = useSelector((state: State) => state.shares);
  const society = useSelector((state: State) => state.society?.actualSociety);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);

  useShares({
    partnerId,
    page: currentPage,
    items: rowsPerPage,
  });

  const useGetShareTitlesResult = UseGetShareTitlesByShares({ shares });

  const { sharesTitles } = useGetShareTitlesResult.data;

  const { document, documentWithCoOwners } = useGetSocietyShareTitleDocument({
    society,
  }).data;

  const handleChangePage = (page: number) => {
    setCurrentPage(page);
  };

  const actualShares = isCoOwner ? coOwnerShares : shares;

  return (
    <>
      <div className="card card-bordered card-preview">
        <PartnerSharesTable
          partnerId={partnerId}
          shares={actualShares}
          sharesTitles={sharesTitles}
          societySharesTitleDocument={document}
          societySharesTitleDocumentWithCoOwners={documentWithCoOwners}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          isAdmin={isAdmin}
          hasSharesTitlesEnabled={hasSharesTitlesEnabled}
          hasMainSharesTitleDisabled={hasMainSharesTitleDisabled}
          isCoOwner={isCoOwner}
          fetchPartnerData={fetchPartnerData}
        />
      </div>

      {!isCoOwner && actualShares?.length > 0 && (
        <DataTablePagination
          itemPerPage={rowsPerPage}
          totalItems={totalItems}
          currentPage={currentPage}
          customItemPerPage={rowsPerPage}
          paginate={handleChangePage}
          setRowsPerPage={setRowsPerPage}
          onChangeRowsPerPage={setRowsPerPage}
          className="card-pagination-small border border-top-0 bg-lighter"
        />
      )}
    </>
  );
};

export default PartnerSocietySharesDetails;
